import React from 'react';
import PropTypes from 'prop-types';
import { useProjectEntitlements } from '@adsk/alloy-provider';
import EntitlementsErrorPage from './EntitlementsErrorPage';
import NoAccessPage from './NoAccessPage';

/**
 * If we handle the error somehow else (redirectUrl or redirect to login page) we don't want to trigger user provider fetch.
 * We trigger it bby calling `useOptionalUser` inside NoAccessPage or EntitlementsErrorPage, so this check would remove this call.
 *
 * @param error
 * @return {string|boolean}
 */
const isErrorHandledSomewhereElse = error => error.redirectUrl || error.status === 401;
const EntitlementsErrorConditionalRenderer = _ref => {
  let {
    children,
    onLogout
  } = _ref;
  const {
    error,
    currentProject
  } = useProjectEntitlements();
  const showNoAccess = !!error && error.status === 403;
  if (showNoAccess) {
    return /*#__PURE__*/React.createElement(NoAccessPage, {
      onLogout: onLogout
    });
  }
  const showErrorPage = !!error && !currentProject && !isErrorHandledSomewhereElse(error);
  if (showErrorPage) {
    return /*#__PURE__*/React.createElement(EntitlementsErrorPage, {
      onLogout: onLogout
    });
  }
  return children;
};
EntitlementsErrorConditionalRenderer.propTypes = {
  /** The content to show if user has access */
  children: PropTypes.node,
  /** callback called on logout */
  onLogout: PropTypes.func
};
export { EntitlementsErrorConditionalRenderer };
//# sourceMappingURL=EntitlementsErrorConditionalRenderer.js.map